import './assets/common.less';
import './assets/index.less';
import './assets/index';
import './assets/common';

// window.__config_data_base = {
//     templateId: "5", //活动id
//     leader_page_link: "//promotion.aliyun.com/ntms/act/aliyun-group/team.html", //组长页链接
//     buy_link: '//promotion.aliyun.com/ntms/act/aliyun-group/buy.html', // 购买页链接
//     stop_time: "2018-07-23 18:55:49",
//     home_link: "//promotion.aliyun.com/ntms/act/aliyun-group/home.html",// 首页链接
// }


// WEBPACK FOOTER //
// ./src/index.js